module.exports = __webpack_public_path__ + "static/media/011_G6_5Revised Showlist 5-24.cfa4dd05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/011_G6_5Revised Showlist 5-24.png
// module id = 436
// module chunks = 0